// extracted by mini-css-extract-plugin
export var heroImage = "HeroPanel-module--heroImage--ORVsK";
export var visible = "HeroPanel-module--visible--MGVnb";